<template>
  <div class="placeOrder">
    <template v-if="controllerNumber.length">
      <ticketInfo
      :selectDate="selectDate"
      :fullTicketInfo="fullTicketInfo"
      :controllerNumber="controllerNumber">
      </ticketInfo>
      <fillContacts
        v-if="
          !(
            screenData.needContactName == 'false' &&
            screenData.needContactMobile == 'false' &&
            screenData.needContactEmail == 'false' &&
            screenData.needContactHKMTPassport == 'false' &&
            screenData.needContactIDCard == 'false' &&
            screenData.needContactPassport == 'false'
          )
        "
        :realName="userInfo.realName"
        :mobile="userInfo.mobile"
        :email="userInfo.email"
        :idCardNo="userInfo.idCardNo"
        @matchContact="matchContact"
        :hmt="hmt"
        :screenData="screenData">
        </fillContacts>
      <!-- <topContacts
        ref="DOMTopContacts"
        :controllerNumber="controllerNumber"
        @changeTopContacts="changeTopContacts"
        :usefulPersonInfos="usefulPersonInfos">
      </topContacts> -->
      <inputDevice
        :selectDate="selectDate"
        @updataControllerNumber="updataControllerNumber"
        ref="DOMInputDevice"
        :controllerNumber="controllerNumber">
      </inputDevice>
      <calculationAction
        ref="DOMCalculationAction"
        :nextStepName="'Pay'"
        @nextStep="nextStep"
        :fullPrice="Number(fullPrice)"
        :controllerNumber="controllerNumber"
        ></calculationAction>
      <multiTicketDiversion
        v-if="touristShuntSwitch"
        @clickPopup="clickPopup"
        :tourist="usefulPersonInfos[usefulPersonInfoActiveIndex]"
        :touristShuntSwitch="touristShuntSwitch"
        :hitUsefulPersonInfo="hitUsefulPersonInfo">
      </multiTicketDiversion>
    </template>
    <selectpopup v-if="popupstate" @onselectpopup="onselectpopup" title="tip" :content="selectPopupText"/>
  </div>
</template>

<script>
import loading from '@/components/common/loading';
import ticketInfo from "@/components/buyTickets/placeOrderEn/ticketInfo";
import fillContacts from "@/components/buyTickets/placeOrderEn/fillContacts";
import { getCreateOrder } from "@/service/buyTickets/touristfit.js";
import topContacts from "@/components/buyTickets/placeOrderEn/topContacts";
import inputDevice from "@/components/buyTickets/placeOrderEn/inputDevice";
import multiTicketDiversion from "@/components/buyTickets/placeOrderEn/multiTicketDiversion";
import calculationAction from "@/components/buyTickets/shoppingCart/calculationActionEn";
import {
  getUsefulPerson,
  getUsefulPersonUpdPerson,
  getUsefulPersonBatchAddPersonn,
} from "@/service/oftencontact/oftencontactList.js";

export default {
  name: "touristhmtPlaceOrder",
  data() {
    return {
      controllerNumber: [],
      fullTicketInfo: {},
      fullPrice: 0,
      selectDate: {},
      userInfo: {},
      contactItems: {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        contactCerType: "passport",
        contactCerNo: "",
      },
      usefulPersonInfos: [],
      hitUsefulPersonInfo: [],
      usefulPersonInfoActiveIndex: null,
      touristShuntSwitch: false,
      createdDoading: loading(),
      screenData: {},
      popupTicket: null,
      popupstate: false,
      selectPopupText: '',
      hmt: false, // 是否是外籍票 默认否
    }
  },
  created(){
    const keepState = this.initialization();
    if(keepState){
      this.getUserInfo();
      this.getCommonVisitors();
    };
  },
  methods: {
    initialization(){
      const orderinformation = JSON.parse(window.sessionStorage.getItem('orderinformation')) || false;
      if(!orderinformation){
        this.$router.push('/');
        return false;
      }
      const { controllerNumber, selectDate, fullTicketInfo } = orderinformation;
      const _controllerNumber = JSON.parse(window.sessionStorage.getItem('controllerNumber')) || false;
      if(_controllerNumber){
        this.controllerNumber = _controllerNumber;
      }else{
        this.controllerNumber = controllerNumber;
      };
      this.fullTicketInfo = fullTicketInfo;
      // 外籍票的code 写死在程序中
      const hmtCodes = ["tg_01_04", "tg_01_05", "tg_01_07"];
      this.hmt = hmtCodes.includes(fullTicketInfo.code)
      this.selectDate = selectDate;
      // find -> 免费景点票（其它证件）
      this.popupTicket = this.controllerNumber.some((v) => {
        if(v.count <= 0)return false;
        if(v.metaTicketInfo.productSn == 'STI100006'){
          this.selectPopupText = '请务必携带残疾证、军人证、消防员证等有效证件和身份证并提前出示，扫码入园。';
          return true;
        }
      });
      this.generateScreenData();
      return true;
    },
    onselectpopup(state){
      if(state === 'determine'){
        this.popupTicket = null;
        this.nextStep();
      };
      this.popupstate = false;
    },
    mergeCommonVisitors(target, tourist){
      target.traverllerCerNo = tourist.certNo;
      target.traverllerCerType = tourist.certType;
      target.traverllerEmail = tourist.email;
      target.traverllerName = tourist.name;
      target.traverllerPhone = tourist.mobile;
      if(tourist.id){
        target.id = tourist.id;
      }
    },
    clickPopup({ type, index = null }){
      const _controllerNumber = this.$refs.DOMInputDevice._controllerNumber;
      const ticket = _controllerNumber.find(v => v.metaTicketInfo.productId === this.hitUsefulPersonInfo[index].metaTicketInfo.productId);
      const tourist = this.usefulPersonInfos[this.usefulPersonInfoActiveIndex];
      if(type === 'determine'){
        const isSurplus = ticket.orderItemAttr.some(v => {
          if(!v.traverllerCerNo){
            this.mergeCommonVisitors(v, tourist)
            return true;
          };
        });
        if(!isSurplus){
          const currentOrderItem = ticket.orderItemAttr[0];
          this.usefulPersonInfos.some(v => {
            if(v.certNo === currentOrderItem.traverllerCerNo){
              v.active = false;
              return true;
            };
          });
          this.mergeCommonVisitors(currentOrderItem, tourist)
        };
      };
      this.$refs.DOMTopContacts.$forceUpdate();
      this.$refs.DOMInputDevice.$forceUpdate();
      if(type === 'cancel'){
        tourist.active = false;
      }
      this.touristShuntSwitch = false;
      this.$beyondHiding(false);
    },
    updataControllerNumber({
      type,
      data,
      currentItem,
    }){
      if(type === 'updata'){
        this.controllerNumber.forEach((v, i) => v.orderItemAttr = data[i].orderItemAttr);
      } else if(type === 'delete'){
        this.controllerNumber.forEach((v, i) => v.orderItemAttr = data[i].orderItemAttr);
        this.deleteControllerNumber(currentItem);
      };
    },
    deleteControllerNumber(currentItem){
      this.usefulPersonInfos.some(v => {
        if(v.certNo === currentItem.traverllerCerNo){
          v.active = false;
          return true;
        };
      });
      this.$refs.DOMTopContacts.$forceUpdate();
    },
    generateScreenData(){
      const controllerNumber = this.controllerNumber;
      const checkMergeRule = Boolean(controllerNumber.filter(v => v.count).length > 1);
      if(checkMergeRule){
        const screenData = controllerNumber[0].metaTicketInfo;
        controllerNumber.forEach(({ metaTicketInfo }) => {
          if(metaTicketInfo.needContactEmail === 'true')screenData.needContactEmail = metaTicketInfo.needContactEmail;
          if(metaTicketInfo.needContactHKMTPassport === 'true')screenData.needContactHKMTPassport = metaTicketInfo.needContactHKMTPassport;
          if(metaTicketInfo.needContactIDCard === 'true')screenData.needContactIDCard = metaTicketInfo.needContactIDCard;
          if(metaTicketInfo.needContactMobile === 'true')screenData.needContactMobile = metaTicketInfo.needContactMobile;
          if(metaTicketInfo.needContactName === 'true')screenData.needContactName = metaTicketInfo.needContactName;
          if(metaTicketInfo.needContactPRC === 'true')screenData.needContactPRC = metaTicketInfo.needContactPRC;
          if(metaTicketInfo.needContactPassport === 'true')screenData.needContactPassport = metaTicketInfo.needContactPassport;
        });
        this.screenData = screenData;
      }else{
        this.screenData = controllerNumber.find(v => v.count).metaTicketInfo;
      };
    },
    async nextStep(){
      this.$refs.DOMCalculationAction.changeDetailed(false);
      // 匹配联系人校验规则元门票数据
      const screenData = this.screenData;
      // 校验联系人
      if (screenData.needContactName === "true" && !this.contactItems.contactName)return this.$toast("Please enter the contact person's name");
      if (screenData.needContactMobile === "true" && !this.contactItems.contactPhone)return this.$toast("Please enter the contact phone number");
      if (screenData.needContactEmail === "true" && !this.contactItems.contactEmail)return this.$toast("Please enter the contact email address");
      if (!(screenData.needContactIDCard === "false" && screenData.needContactHKMTPassport === "false" && screenData.needContactPassport === "false" && screenData.needContactPRC === "false") && !this.contactItems.contactCerNo)
      return this.$toast("Please enter the contact person's ID number");
      if(this.hmt && screenData.needContactMobile === "true") {
        const regex = /^([+\d]([ +\d]*[0-9])?){5,20}$/;
        console.log(!regex.test(this.contactItems.contactPhone))
        if(!regex.test(this.contactItems.contactPhone)) {
          return this.$toast('Contact phone format error')
        }
      }else {
        if (screenData.needContactMobile === "true" && !this.$reg.checkPhone(this.contactItems.contactPhone) && !this.$reg.checkLandline(this.contactItems.contactPhone))return this.$toast("Contact phone format error");
      }
      // console.log(this.hmt && screenData.needContactMobile === "true")
      // return false
      if (screenData.needContactEmail === "true" && !this.$reg.checkEmail(this.contactItems.contactEmail))return this.$toast("Contact email format error");
      if (screenData.needContactIDCard === "true" && !this.$reg.checkIDCard(this.contactItems.contactCerNo))return this.$toast("Contact ID card format error");
      // 输入组件自我检查并返回检查结果
      const failText = this.$refs.DOMInputDevice.checkControllerNumber();
      if(failText)return this.$toast(failText);
      const saleDate = this.selectDate;
      const { periodId } = saleDate.datePeriodInfo;
      let parameter = {
        appCode: "pdc7vkn6",
        userId: this.userInfo.userId,
        contactName: this.contactItems.contactName,
        contactPhone: this.contactItems.contactPhone,
        contactEmail: this.contactItems.contactEmail,
        contactCerType: this.contactItems.contactCerType,
        contactCerNo: this.contactItems.traverllerCerNo,
        payType: "WEIXIN",
        orderItems: []
      };
      // if(this.popupTicket)return this.popupstate = true;
      this.controllerNumber.forEach(item => {
        const { needCertAsMedia, productId } = item.metaTicketInfo;
        const currentTag = item.metaTicketInfo.attrInfos.find(v => v.friendlyName === 'SALE_TYPE').key === 'full' ? 'adult' : 'student';
        if(!item.orderItemAttr.length)return;
        // 一个二维码一个人
        if (needCertAsMedia === "true") {
          item.orderItemAttr.forEach((traverller) => {
            const options = {
                ticketId: productId,
                playDate: saleDate.saleDate,
                playPeriodId: periodId,
                attrList: [traverller],
                playCount: 1,
                tag: currentTag,
            };

            options.traverllerName = traverller.traverllerName;
            options.traverllerPhone = traverller.traverllerPhone;
            options.traverllerEmail = traverller.traverllerEmail;
            options.traverllerCerType = traverller.traverllerCerType;
            options.traverllerCerNo = traverller.traverllerCerNo.toUpperCase();
            traverller.traverllerCerNo = traverller.traverllerCerNo.toUpperCase();
            parameter.orderItems.push(options);
          });
        }else{
          // 一个二维码多人
          const options = {
              ticketId: productId,
              playDate: saleDate.saleDate,
              playPeriodId: periodId,
              attrList: item.orderItemAttr,
              playCount: item.orderItemAttr.length,
              tag: currentTag,
          };
          parameter.orderItems.push(options);
        };
      });
      this.upUserInfoData();
      this.upGroupUserInfo();
      await this.mergeUsefulPersonInfos(parameter.orderItems);
      const data = await getCreateOrder.call(this, parameter);
      if(!data.data)return;
      const { orderId } = data.data;
      const pathDetails = 'touristorderdetailsEn';
      const callback = {
        orderId,
        orderType: 0,
        orderSource: 'WX',
        returnUrl: encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/${pathDetails}?orderId=${orderId}`),
        errorUrl: encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/${pathDetails}?orderId=${orderId}`),
      };
      window.sessionStorage.removeItem('orderinformation');
      window.sessionStorage.removeItem('controllerNumber');
      window.sessionStorage.removeItem('oftenContacts');
      this.createdDoading.loadingStata = true;
      // location.href = `${process.env.VUE_APP_BASE_URL}/wechat/pay?orderId=${callback.orderId}&orderType=${callback.orderType}&returnUrl=${callback.returnUrl}&errorUrl=${callback.errorUrl}`;
      location.href = `${process.env.VUE_APP_BASE_URL}/unified/pay?orderId=${callback.orderId}&orderSource=${callback.orderSource}&orderType=${callback.orderType}&returnUrl=${callback.returnUrl}&errorUrl=${callback.errorUrl}`;
      setTimeout(() => {
        this.createdDoading.loadingStata = false;
        this.$beyondHiding(false);
      }, 3000);
    },
    upUserInfoData(){
      const userInfo = this.userInfo;
      userInfo.mobile = this.contactItems.contactPhone;
      if(userInfo.realName){
        userInfo.realName = this.contactItems.contactName;
      }else{
        userInfo.name = this.contactItems.contactName;
      };
      userInfo.email = this.contactItems.contactEmail;
      if(userInfo.idCard && this.$reg.checkIDCard(userInfo.idCard))this.contactItems.contactCerNo = userInfo.idCard;
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    upGroupUserInfo(){
      let groupUserInfo = this.userInfo.extField1
      if(!groupUserInfo)return;
      groupUserInfo = JSON.parse(groupUserInfo);
      groupUserInfo.mobile = this.contactItems.contactPhone;
      groupUserInfo.realName = this.contactItems.contactName;
      groupUserInfo.email = this.contactItems.contactEmail;
      if(groupUserInfo.idCard && this.$reg.checkIDCard(groupUserInfo.idCard))this.contactItems.contactCerNo = groupUserInfo.idCard;
      window.sessionStorage.setItem('groupUserInfo', JSON.stringify(groupUserInfo));
    },
    async mergeUsefulPersonInfos(orderItems) {
      // 本次需完成 添加 、修改
      const usefulPersonInfos = this.usefulPersonInfos;
      // 1.取出修改过的那组数据
      const selectCommonVisitors = orderItems.filter((v) => v.attrList[0].id);
      let updateOrderItems = [];
      if (selectCommonVisitors.length) {
        updateOrderItems = selectCommonVisitors.filter((v) => {
          const item = usefulPersonInfos.find((v1) => v1.id === v.attrList[0].id);
          if (item) {
            return (
              v.attrList[0].traverllerCerNo != item.certNo ||
              v.attrList[0].traverllerCerType != item.certType ||
              v.attrList[0].traverllerEmail !== item.email ||
              v.attrList[0].traverllerName != item.name ||
              v.attrList[0].traverllerPhone != item.mobile ||
              v.attrList[0].tag != item.tag ||
              v.attrList[0].tag === 'un_set'
            );
          }
        });
      };
      if (updateOrderItems.length) {
        const updataGroup = updateOrderItems.map((v) => {
          const parameter = {
            id: v.attrList[0].id,
            userId: this.userInfo.userId,
            name: v.attrList[0].traverllerName,
            mobile: v.attrList[0].traverllerPhone,
            email: v.attrList[0].traverllerEmail || "",
            certType: v.attrList[0].traverllerCerType,
            certNo: v.attrList[0].traverllerCerNo,
            ifDefault: "1",
            personType: "traveller",
            tag: v.tag,
          };
          return getUsefulPersonUpdPerson.call(this, parameter);
        });
        // 并发发送更改的数据
        await Promise.all(updataGroup);
      };
      // 2.取出新数据
      let addOrderItems = orderItems.filter((v) => !v.attrList[0].id);
      if (addOrderItems.length) {
        const usefulPersons = addOrderItems.map((v) => {
          const queue = v.attrList.map(v1 => {
            const parameter = {
              name: v1.traverllerName,
              mobile: v1.traverllerPhone,
              email: v1.traverllerEmail || "",
              certType: v1.traverllerCerType,
              certNo: v1.traverllerCerNo,
              tag: v.tag,
            };
            return parameter;
          });
          return queue;
        }).flat().filter(v => !usefulPersonInfos.some(v1 => v1.certNo === v.certNo));
        if(!usefulPersons.length || usefulPersonInfos.length >= 10)return;

        const allowance = process.env.VUE_APP_MAX_NUMBER_VISITORS - (usefulPersonInfos.length + usefulPersons.length);
        if(allowance < 0){
          for(let i = 0; i < Math.abs(allowance); i++){
            usefulPersons.pop()
          }
        }
        await getUsefulPersonBatchAddPersonn.call(this, {
          userId: this.userInfo.userId,
          personType: "traveller",
          usefulPersons,
          certTypes: ['hkmo_id_card']
        });
      };
    },
    matchContact(options) {
      switch (options.type) {
        case "needContactName":
          this.contactItems.contactName = options.value;
          this.userInfo.name = options.value;
          break;
        case "needContactMobile":
          this.contactItems.contactPhone = options.value;
          this.userInfo.mobile = options.value;
          break;
        case "needContactEmail":
          this.contactItems.contactEmail = options.value;
          this.userInfo.email = options.value;
          break;
        case "contactCerType":
          this.contactItems.contactCerType = options.value;
          break;
        case "contactCerNo":
          this.contactItems.contactCerNo = options.value;
          this.userInfo.idCard = options.value;
      }
    },
    getUserInfo() {
      this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      this.contactItems.contactPhone = this.userInfo.mobile;
      this.contactItems.contactName = this.userInfo.realName || this.userInfo.name;
      this.contactItems.contactEmail = this.userInfo.email;
      this.contactItems.contactCerNo = this.userInfo.idCard;
    },
    async getCommonVisitors() {
      const oftenContacts = JSON.parse(sessionStorage.getItem("oftenContacts"));
      if (oftenContacts) {
        this.usefulPersonInfos = oftenContacts;
      } else {
        const certTypes = ["passport", "hkmo_id_card", "prc"];
        const { data } = await getUsefulPerson.call(this, {
          userId: this.userInfo.userId,
          certTypes,
        });
        const { usefulPersonInfos } = data;
        this.usefulPersonInfos = usefulPersonInfos;
      };
      this.$nextTick(this.updataTopContactsInputDevice);
    },
    updataTopContactsInputDevice(){
      const _controllerNumber = this.$refs.DOMInputDevice._controllerNumber;
      this.usefulPersonInfos.forEach(item => {
        const { tag } = item;
        if(item.active){
          _controllerNumber.some(v => {
            const { count } = v;
            if(count === 0)return false;
            const currentTag = this.$getTicketTag(v.metaTicketInfo.attrInfos);
            if(v.orderItemAttr.length){
              v.orderItemAttr.some(v1 => {
                if(v1.traverllerCerNo)return true;
                if(!v1.traverllerCerNo && (tag === 'un_set') || (tag === currentTag)){
                  this.mergeCommonVisitors(v1, item)
                  return true;
                }
              });
              return true;
            };
          })
        };
      });
      this.$refs.DOMInputDevice.$forceUpdate();
    },
    changeTopContacts({ active, index, tag }){
      const { _controllerNumber } = this.$refs.DOMInputDevice;
      const currentItem = this.usefulPersonInfos[index];
      currentItem.active = active;
      if(!active){
        _controllerNumber.some(item => {
          return item.orderItemAttr.some(v => {
            if(v.traverllerCerNo === currentItem.certNo){
              v.traverllerCerNo = '';
              v.traverllerCerType = 'passport';
              v.traverllerEmail = '';
              v.traverllerName = '';
              v.traverllerPhone = '';
              v.id = '';
              return true;
            }
          });
        });
      } else {
        const hitList = _controllerNumber.reduce((totalList, currentValue, currentIndex, arr) => {
          const orderSection = currentValue.metaTicketInfo.attrInfos.find(v => v.friendlyName === 'SALE_TYPE').key;
          if((currentValue.orderItemAttr.length)){
            if((tag === 'un_set') || (tag === 'student' && orderSection === 'half') || (tag === 'adult' && orderSection === 'full')){
              totalList.push(currentValue);
            };
          };
          return totalList;
        }, []);
        if(!hitList.length){
          this.$toast('Tourists do not meet the age limit for the applicable population');
          currentItem.active = !currentItem.active;
          return;
        };
        if(hitList.length === 1){
          // 1.自动选择区
          // 循环判断有无余量(当有余量时直接添加)
          const isSurplus = _controllerNumber.some(item => {
            const orderSection = item.metaTicketInfo.attrInfos.find(v => v.friendlyName === 'SALE_TYPE').key;
            return item.orderItemAttr.some(v => {
              if(!v.traverllerName && (((tag === 'un_set')) || (tag === 'student' && orderSection === 'half') || (tag === 'adult' && orderSection === 'full'))){
                this.mergeCommonVisitors(v, currentItem)
                return true;
              };
            });
          });
          // 2.无余量需要替换首个并且把首个得高亮关闭
          if(!isSurplus){
            _controllerNumber.some(item => {
              const orderSection = item.metaTicketInfo.attrInfos.find(v => v.friendlyName === 'SALE_TYPE').key;
              return item.orderItemAttr.some(v => {
                if(v.traverllerName && (((tag === 'un_set')) || (tag === 'student' && orderSection === 'half') || (tag === 'adult' && orderSection === 'full'))){
                  this.mergeCommonVisitors(v, currentItem)
                  return true;
                }
              });
            });
            const usefulPersonCerNos = _controllerNumber.reduce((totalList, currentValue, currentIndex, arr) => {
              currentValue.orderItemAttr.forEach(v => totalList.push(v.traverllerCerNo));
              return totalList;
            }, []);
            this.usefulPersonInfos.forEach(item => {
              if(!usefulPersonCerNos.includes(item.certNo)){
                item.active = false;
              }
            });
          };
        }else{
          // 2.出现多个符合条件票种的自选区
          this.hitUsefulPersonInfo = hitList;
          this.usefulPersonInfoActiveIndex = index;
          this.touristShuntSwitch = true;
          this.$beyondHiding(true);
        };
      }
      this.$refs.DOMInputDevice.$forceUpdate();
    },
  },
  watch: {
    controllerNumber: {
      handler(newValue){
        const fullPrice = newValue.reduce((total, currentValue, currentIndex, arr) => {
          total += Number(currentValue.salePrice) * currentValue.count;
          return total;
        }, 0);
        this.fullPrice = String(fullPrice.toFixed(2)).padStart(2, 0);
      },
      deep: true,
    }
  },
  components: {
    ticketInfo,
    fillContacts,
    topContacts,
    inputDevice,
    calculationAction,
    multiTicketDiversion,
  }
};
</script>
